import { Typography } from '@mui/material';
import { useGetJobPostCompanyStatisticsQuery } from '../../../../store/apiSlice/jobpost/jobpostApi';

type JobPostsCompanyStatisticsProps = {
  companyId: string;
};

const JobPostsCompanyStatistics = ({
  companyId,
}: JobPostsCompanyStatisticsProps) => {
  const { data: companyStatistics } =
    useGetJobPostCompanyStatisticsQuery(companyId);

  if (!companyStatistics) return null;

  return (
    <>
      <Typography component={'p'} fontSize={'12px'} fontWeight={700}>
        {`${companyStatistics.totalJobPosts ?? 0} job posted:`}
      </Typography>
      <Typography variant="body3">
        {`${companyStatistics.hireRate ? Math.round(companyStatistics.hireRate) : 0}% hire rate, ${companyStatistics.totalActiveJobPosts ?? 0} open job`}
      </Typography>
    </>
  );
};

export default JobPostsCompanyStatistics;
